import { MODULE_NAME } from '../strings'
import { I18nBundle } from 'shared/types'
import enTranslation from './en.json'
import plTranslation from './pl.json'
import esTranslation from './es.json'
import frTranslation from './fr.json'
import deTranslation from './de.json'

const translations: I18nBundle[] = [
  ['en', MODULE_NAME, enTranslation],
  ['pl', MODULE_NAME, plTranslation],
  ['es', MODULE_NAME, esTranslation],
  ['fr', MODULE_NAME, frTranslation],
  ['de', MODULE_NAME, deTranslation],
]

export default translations
